import { OrbitControls } from '@react-three/drei';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { MdOutlineClose } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import ThreeDModelViewer from '../../Model/ThreeDModelViewer';
import { Canvas } from '@react-three/fiber';
import "./ManageProduct.css"

const ManageProduct = () => {
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
     const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = () => setOpen(!open);

    useEffect(() => {
      axios
        .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/products`)
        .then((res) => setProducts(res.data))
        .catch((err) => console.error("Error fetching products", err));
       
        
    },
     []);

     const onDelete = (products) => {
      console.log("delete", products);
      setOpenDropdown(null);
      setOpen(false);
      
     };

    const handleEdit = (products) => {
        console.log("products", products);
        setOpenDropdown(null);
        setOpen(false);
        
      navigate(`/admin/edit-product/${products}`);
    };
    const addProduct = ()=>{
      navigate(`/admin/add-product`);
    }

    return (
      <div className="orders-container">
        <div
          className="orders-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h2 style={{ color: "#e6651b" }}>All Products</h2>

          <button
            className="add-product-btn"
            style={{ backgroundColor: "#e6651b", color:"white",border:"none" }}
            onClick={addProduct}
          >
            ADD Product
          </button>
        </div>
        <table className="orders-table">
          <thead>
            <tr>
              {/* <th>Id</th> */}
              <th>Name</th>
              <th>image</th>
              <th>size</th>
              <th>Available Colors</th>
              <th>Price</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            {products.length > 0 ? (
              products.map((item, index) => (
                <tr>
                  <td>
                    <h4>{item.title}</h4>
                  </td>
                  <td data-label="Product">
                    <div className="shoppingBagTableImg">
                      {/* <Link state={{ objectColors: item.objectColors }}> */}
                      {item.path ? (
                        // ✅ Render 3D model if item has `image` (assuming it's a GLB path)
                        <Canvas
                          camera={{
                            position: [3, 3, 5],
                            fov: 35,
                          }}
                        >
                          <ambientLight intensity={0.6} />
                          <directionalLight position={[2, 2, 2]} />
                          <React.Suspense fallback={null}>
                            <ThreeDModelViewer
                              path={item.path}
                              objectColors={item.objectColors}
                            />
                          </React.Suspense>
                          <OrbitControls />
                        </Canvas>
                      ) : (
                        // ) : item.frontImg ? (
                        //   // ✅ Fallback to image if item has `frontImg`
                        //   <img src={item.frontImg} alt={item.productName} />
                        // Optional fallback
                        <p>No preview</p>
                      )}
                      {/* </Link> */}
                    </div>
                  </td>
                  <td data-label="">
                    <div className="shoppingBagTableProductDetail">
                      <p>{item.size.join(",")}</p>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                    >
                      {item.availableColors.map((color, index) => {
                        return (
                          <button
                            key={index}
                            style={{
                              backgroundColor: color,
                              width: 20,
                              height: 20,
                              borderRadius: "50%",
                              outline: "none",
                            }}
                            title={color}
                          />
                        );
                      })}
                    </div>
                  </td>
                  <td data-label="Price" style={{ textAlign: "center" }}>
                    ${item.price}
                  </td>
                  <td>
                    <div className="dropdownWrapper">
                      <p
                        className="actionBtn"
                        onClick={() =>
                          setOpenDropdown(openDropdown === index ? null : index)
                        }
                      >
                        ...
                      </p>

                      {openDropdown === index && (
                        <div className="dropdownMenu">
                          <div onClick={() => handleEdit(item._id)}>Edit</div>
                          <div onClick={() => onDelete(item._id)}>Delete</div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <p>Somthing went wrong</p>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

export default ManageProduct
